export default __webpack_public_path__ + "static/media/documents-empty-light.1b7f3252.png";